import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../../common/core/ResponsivePage";
import config from "../../../../config";
import { useNavigate } from "react-router";
import { DeleteOutline as DeleteIcon } from "@mui/icons-material";
import { Task, useEntity } from "@emberly/zenith-client";
import ConfirmDialog from "../../../common/inputs/ConfirmDialog";
import { useDevice } from "../../../../providers/DeviceProvider";




const truncateName = (name) => {
  return name.length > 16 ? name.substr(0,16) + "..." : name;
};

export default function MissionFormLayout(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { entity, hasUpdate, deleteEntity } = useEntity();
  const [deleteAction, setDeleteAction] = useState(null);
  const { slim } = useDevice();

  const menuItems = useMemo(() => [
    {
      label: t("missionForm:delete"),
      icon: <DeleteIcon />,
      onClick: async () => {
        try {
          const t = new Task();
          setDeleteAction(t);
          await t.wait();
          deleteEntity();
          navigate("../", { relative: "path" });
        } catch (err) {
          console.log(err);
        } finally {
          setDeleteAction(null);
        }
      }
    },
  ], [t, navigate, deleteEntity]);


  return (
    <ResponsivePage
      title={`${t("missionForm:title")}${!!entity && !slim ? ` - ${truncateName(entity.name)}${hasUpdate ? "*" : ""}` : ""}`}
      maxWidth={config.pageSize.small}
      menuItems={menuItems}
      backButton
    >
      {props.children}

      <ConfirmDialog
        task={deleteAction}
        title={t("missionForm:deleteDialog:title")}
        description={t("missionForm:deleteDialog:description")}
        confirmText={t("common:delete")}
        color="error"
      />

    </ResponsivePage>
  );
}